import { useMemo } from "react";

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const usePublisherFactory = ({ fetch, siteSelected: { id: site_id }, collection: { collectionURL } }) => useMemo(() => ({
  references: {
    useLoad: async publisherId => {
      const result = await fetch({
        method: 'get',
        url: `${collectionURL}/${publisherId}/allocations`,
        params: { site_id },
      });
      if (!result) {
        throw Error()
      }
      return result
    },
  },
}), [collectionURL, fetch, site_id])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('publisher')
  .extendHookCollectionsFactory('publishers')
  .extend(usePublisherFactory)
  .factory()

export {
  Provider as PublisherProvider,
  useStore as usePublisherStore,
}
